import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import style from './style.module.scss';
import { Row, Col, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const FileUpload = ({ file, setFile, preview, setPreview }) => {
  const [previewModal, setPreviewModal] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Row className="pt-4">
        <Col>
          <Dropzone
            accept="image/jpeg, image/png"
            multiple={false}
            onDrop={acceptedFiles => {
              setFile(acceptedFiles);
              setPreview(
                acceptedFiles.length !== 0
                  ? URL.createObjectURL(acceptedFiles[0])
                  : null
              );
            }}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject
            }) => (
              <section>
                <div
                  {...getRootProps({
                    className:
                      style.dropzone +
                      (isDragActive ? ' active' : '') +
                      (isDragAccept ? ' accept' : '') +
                      (isDragReject ? ' reject' : '')
                  })}
                >
                  <input {...getInputProps()} />
                  {!isDragActive ? (
                    <span>{t('label:drag here')}</span>
                  ) : isDragAccept ? (
                    <span>{t('label:drop now')}</span>
                  ) : (
                    <span>{t('label:file not accepted')}</span>
                  )}
                </div>
              </section>
            )}
          </Dropzone>
        </Col>
        <Col md={2}>
          <div className={style.img_preview}>
            {!preview ? (
              <span>{t('label:preview')}</span>
            ) : (
              <>
                <img
                  className="thumb"
                  alt={t('label:logo preview')}
                  src={preview}
                  onClick={() => setPreviewModal(true)}
                />

                <Modal
                  size="md"
                  show={previewModal}
                  onHide={() => setPreviewModal(false)}
                >
                  <Modal.Header closeButton>
                    {t('label:logo preview')}
                  </Modal.Header>
                  <Modal.Body>
                    <img
                      alt={t('label:logo preview')}
                      width="100%"
                      heigth="100%"
                      src={preview}
                    />
                  </Modal.Body>
                </Modal>
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FileUpload;
